import {getFromKey} from '../services/message-filters';

export const getSelectedFolderMessageList = state => {
  const {application, messages} = state;
  if (application && application.selectedFolderId && messages && messages.cache[application.selectedFolderId]) {
    const messageFilter = getFromKey(application.messageFilterKey);
    if (application.messageFilterKeyword){
      return messageFilter.selector(Array.from(Object.values(state.messages.cache[state.application.selectedFolderId] || {})), application.messageFilterKeyword,application.filteredMessages)
      .sort((a, b) => {
        if (a.receivedDate > b.receivedDate) {
          return -1;
        } else if (a.receivedDate < b.receivedDate) {
          return 1;
        }
        return 0;
      });
    }
    else {
      return messageFilter.selector(Array.from(Object.values(state.messages.cache[state.application.selectedFolderId] || {})))
      .sort((a, b) => {
        if (a.receivedDate > b.receivedDate) {
          return -1;
        } else if (a.receivedDate < b.receivedDate) {
          return 1;
        }
        return 0;
      });
    }
  }
  return [];
};

// Selector para obtener el array [{key, value}, ...]
export const getFolderMessagesAsArray = (state, folderId) =>
  Object.entries(state.messages.cache[folderId] || {}).map(([key, value]) => ({
  key,
  value
  }));